import React from "react";
import AllSubjectTopics from "../../../topics/AllSubjectTopics";


function FlashcardChemTopics() {
  return (
    <>

      <AllSubjectTopics  subject="chemistry" type="flashcard" />


    </>
  );
}

export default FlashcardChemTopics;